import browserUpdate from "browser-update";

export default function () {
    browserUpdate({
        required: {
            e: -4,
            f: -3,
            s: -1,
            c: -3,
            o: -3,
            i: 12,
            insecure: true,
            unsupported: true,
        },
    });
}
